import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { ENV } from '@shared/config/env'
import { getProfile } from '@entities/user'
import { useAppStore } from '@/store/useAppStore'
import { usePlatform } from '@shared/platform'
import { ROUTES } from '@shared/config/routes'
import { LinkEmailModal } from './LinkEmailModal'

const DISMISS_KEY = 'pauline:link-email-dismissed'

/**
 * Автопоказ модалки привязки email в TG-сборке, если `profile.email == null`.
 * Показывается один раз за сессию (после закрытия). Требует что профиль уже загружен.
 * Подавляется, если юзер пришёл в mini-app по link-коду (start_param=link_code_*)
 * или находится на экране подтверждения связки Telegram.
 */
export const LinkEmailAutoPromptTg = () => {
  const profile = useAppStore((s) => s.profile)
  const setProfile = useAppStore((s) => s.setProfile)
  const authStatus = useAppStore((s) => s.authStatus)
  const platform = usePlatform()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const [checked, setChecked] = useState(false)

  const isOnLinkConfirm = location.pathname.startsWith(ROUTES.LINK_TELEGRAM_CONFIRM)
  const isOnTelegramAuth = location.pathname.startsWith(ROUTES.TELEGRAM_AUTH_CONFIRM)
  const startParam = platform.getStartParam()
  const isLinkCodeFlow = Boolean(startParam?.startsWith('link_code_'))
  const isTelegramAuthFlow = Boolean(startParam?.startsWith('telegram_auth_'))

  useEffect(() => {
    if (!ENV.IS_TG) return
    if (checked) return
    if (authStatus !== 'success') return
    // Не показываем email-промпт во время флоу подтверждения связки/авторизации Telegram
    if (isOnLinkConfirm || isLinkCodeFlow) return
    if (isOnTelegramAuth || isTelegramAuthFlow) return
    setChecked(true)
    if (sessionStorage.getItem(DISMISS_KEY)) return

    const run = async () => {
      // Всегда запрашиваем свежий профиль: persist в localStorage может
      // хранить устаревший снапшот (без email), из-за чего модалка всплывала
      // повторно даже после успешной привязки.
      let p
      try { p = await getProfile(); setProfile(p) } catch { return }
      if (!p.email) setOpen(true)
    }
    void run()
  }, [authStatus, profile, setProfile, checked, isOnLinkConfirm, isLinkCodeFlow, isOnTelegramAuth, isTelegramAuthFlow])

  if (!open) return null
  return (
    <LinkEmailModal
      onClose={() => {
        sessionStorage.setItem(DISMISS_KEY, '1')
        setOpen(false)
      }}
    />
  )
}
